<template>
    <v-container class="d-flex flex-column align-center justify-center text-center" style="height: 100vh;">
        <v-card flat>
            <v-img src="@/assets/Logo-bt-07.png" max-width="300" contain />
        </v-card>
        <h1 class="mt-4">Estamos realizando tareas de mantenimiento</h1>
        <p class="mb-4">Por favor, volvé a intentarlo más tarde. Gracias por tu paciencia.</p>
        <!-- <v-icon size="64" color="primary">mdi-wrench</v-icon> -->

    </v-container>
</template>

<script>
export default {
    name: 'Mantenimiento',
    methods: {

    },
};
</script>

<style scoped>
h1 {
    font-size: 24px;
    font-weight: bold;
}

p {
    font-size: 16px;
    color: #666;
}
</style>